<template>
    <div class="qingwu">
        <div class="admin_main_block">
            <div class="admin_main_block_top">
                <div class="admin_main_block_left">
                    <div>充值金额编辑</div>
                </div>

                <div class="admin_main_block_right">
                    <div><el-button icon="el-icon-back" @click="$router.go(-1)">返回</el-button></div>
                </div>
            </div>

            <div class="admin_form_main">
                <el-form  label-width="100px" ref="info" :model="info">
                    <el-form-item label="币值" prop="F_IN_BIZ" :rules="[{required:true,message:'币值不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" v-model="info.F_IN_BIZ"></el-input></el-form-item>
                    <el-form-item label="金额" prop="F_IN_JINGE" :rules="[{required:true,message:'金额不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" v-model="info.F_IN_JINGE"></el-input></el-form-item>
                    <el-form-item label="折后价" prop="F_IN_ZHEHJ" :rules="[{required:true,message:'折后价不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" v-model="info.F_IN_ZHEHJ"></el-input></el-form-item>
                    <el-form-item label="产品ID" prop="F_IN_PRODUCTID" :rules="[{required:true,message:'产品ID不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" v-model="info.F_IN_PRODUCTID"></el-input></el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('info')">提交</el-button>
                        <el-button @click="resetForm('info')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import wangeditor from "@/components/seller/wangeditor.vue"
export default {
    components: {
        wangeditor,
    },
    props: {},
    data() {
      return {
          edit_id:0,
          info:{
              F_IN_BIZ:'',
              F_IN_JINGE:'',
              F_IN_ZHEHJ:'',
              F_IN_PRODUCTID:''
          },
          list:[],
          upload_headers:{},
      };
    },
    watch: {},
    computed: {},
    methods: {
        resetForm:function(e){
            this.$refs[e].resetFields();
        },
        submitForm:function(e){
            let _this = this;
            // 验证表单
            this.$refs[e].validate(function(res){
                if(res){
                    //  判断是Add 或者 Edit
                    let url = _this.$api.addChongzjelb;
                    if(_this.edit_id>0){
                        url = _this.$api.editChongzjelb+_this.edit_id;
                    }
                    // Http 请求
                    _this.$post(url,_this.info).then(function(res){
                        if(res.code == 200){
                            _this.$message.success("编辑成功");
                            _this.$router.go(-1);
                        }else{
                            _this.$message.error("编辑失败");
                        }
                    });
                }
            });
        },
        get_agreement_info:function(){
            let _this = this;
            this.$get(this.$api.editChongzjelb+this.edit_id).then(function(res){
                _this.info = res.data;
            })

        },
        // 富文本编辑内容变化
        goods_content:function(data){
            this.info.content = data;
        },

        handleAvatarSuccess(res) {
            this.info.F_VR_LIWTP = res.data;
            this.$forceUpdate();
        },
       
    },
    created() {
        this.upload_headers.Authorization = 'Bearer '+localStorage.getItem('token'); // 要保证取到
        // 判断是否是编辑
        this.info.pid = 0;
        if(!this.$isEmpty(this.$route.params.F_IN_ID)){
            this.edit_id = this.$route.params.F_IN_ID;
        }

        if(this.edit_id>0){
            this.get_agreement_info();
        }
        
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>

</style>